<template>
    <v-container class="pa-0 ma-0" fluid flat style="width: 100%">
        <v-card flat color="#FFD375">

            <v-card color="#FFD375" id="tablecard" class="pa-0  my-5" style="width: 800px" flat tile>
                <v-list class="bckgrnd pa-0 ma-0" flat>
                    <v-content>
                        <v-list-item-group v-model="item" color="#FFD375">
                            <v-list-item v-for="(dat, i) in accountdata" :key="i">
                                <v-row color="#FFD375" class="row-pointer">
                                    <v-col cols="4">
                                        <v-list-item-content>
                                            <v-list-item-title class="boldtext" v-text="dat.Name"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-list-item-content>
                                            <v-list-item-title :class="rowstyle(i)" v-text="dat.Actual"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-list-item-content>
                                            <v-list-item-title :class="rowstyle(i)" v-text="dat.Limit"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-col cols="3">
                                        <v-list-item-icon class="px-2 py-0 ma-0" v-if="i==0" @click='changePlanClicked'>
                                            <v-icon color="#000000">swap_horizontal_circle</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content v-else>
                                            <v-list-item-title :class="rowstyle(i)" v-text="dat.Note"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </v-list-item-group>
                    </v-content>
                </v-list>
            </v-card>

        </v-card>

        <PlanPopup v-bind:selectedplan=selectedplan v-model="showPlanPopup" />

    </v-container>
</template>

<script>

    import PlanPopup from '@/views/Settings/PlanPopup';
    import { daysinmonth,contactcount } from '@/functions.js';

    export default {
        mounted: function () {
            this.selectedplan = this.$store.state.useraccount.billing.Plan;
            this.usage = this.$store.state.useraccount.usage;
            this.accountdata[0].Actual = "" + this.selectedplan.Name;
            var v = Number(this.selectedplan.Cost);
            var vv = v.toFixed(2);
            this.accountdata[0].Limit = "\xA3" + vv + "/month";
            var d = new Date();
            var m = d.getMonth()+1;
            var y = d.getYear();
            var nday = d.getDate();
            var mdays = daysinmonth(m,y);
            this.accountdata[1].Note = "Day " + nday + " of " + mdays;
            this.accountdata[2].Actual = Math.round(this.usage.Bandwidth/1000000);
            this.accountdata[2].Limit = Math.round(this.selectedplan.Bandwidth);
            var left2 = Math.round(100 * (this.selectedplan.Bandwidth - (this.usage.Bandwidth / 1000000)) / this.selectedplan.Bandwidth);
            this.accountdata[2].Note = "" + left2 + "% left";

            this.accountdata[3].Actual = Math.round(this.usage.MediaSize / 1000000);
            this.accountdata[3].Limit = Math.round(this.selectedplan.Storage);
            var left3 = Math.round(100 * (this.selectedplan.Storage - (this.usage.MediaSize / 1000000)) / this.selectedplan.Storage);
            this.accountdata[3].Note = "" + left3 + "% available";

            var cc = contactcount();
            this.accountdata[4].Actual = cc;
            this.accountdata[4].Limit = this.selectedplan.Contacts;
            var left4 = Math.round(100 * (this.selectedplan.Contacts - cc) / this.selectedplan.Contacts);
            this.accountdata[4].Note = "" + left4 + "% available";
        },
        data: () => ({
            accountdata: [
                { Name: 'Plan', Actual: '', Limit: "\xA399.99/month", Note: '' },
                { Name: '', Actual: 'Used', Limit: 'Limit', Note: '' },
                { Name: 'Bandwidth (MB/month)', Actual: '', Limit: '', Note:'' },
                { Name: 'Storage (MB)', Actual: '', Limit: '', Note: '50% available' },  
                { Name: 'Contacts', Actual: '', Limit: '', Note: '50% available' },  
            ],
            item: null,
            selectedplan: null,
            usage:null,
            showPlanPopup: false
        }),
        components: {
            PlanPopup
        },
        methods: {
            changePlanClicked() {
                this.showPlanPopup = true;
            },
            rowstyle(i) {
                if (i == 1)
                    return 'boldtext';
                else {
                    return 'normaltext';
                }
            }
        },
        computed: {
        }
    }

    //font-weight: bold;

</script>

<style scoped>
    .bckgrnd {
        background: #FFD375;
    }

    .boldtext {
        color: black;
        font-size: large;
        font-weight: bold;
    }

    .normaltext {
        color: black;
    }

    .row-pointer > tbody tr :hover {
        cursor: pointer;
    }

</style>
